<div id="account-header">
    <div #userOuterEl id="user-outer" (click)="dropdown=!dropdown">
        <img id="user-icon" src="assets/icons/account.svg" />
        <div id="user-name">
            {{ accountService.User.Name }}
        </div>

        <div class="dropdown" [ngClass]="{'active': dropdown}" (click)="onLogoutClick()">
            <img class="dropdown-icon" src="assets/icons/exit-sign.svg" />
            <div class="dropdown-text">
                {{ languageService.languageJSON.AccountHeader_Logout }}
            </div>
        </div>
    </div>
</div>